import React from 'react';
import RcViewer from '@hanyk/rc-viewer';

const options = {
    // 是否显示下面工具栏 1 显示 0 隐藏
    // toolbar: 1,
    navbar: true,       //关闭缩略图
    fullscreen: false,   //播放全屏
    loop: false,         //是否循环 上一个 下一个
    minWidth: '',
    minHeight: '',
    toolbar: {
        zoomIn: { size: 'large' },  //放大
        zoomOut: { size: 'large' }, //缩小
        reset: { size: 'large' },   //重置
        prev: { show: true, size: 'large', }, //上一张
        play: { show: false, size: 'large', },  //播放
        next: { show: true, size: 'large', },  //下一张
        rotateLeft: { size: 'large' },  //左旋转
        rotateRight: { size: 'large' }, //右旋转
        flipHorizontal: { size: 'large' },  //左右翻转
        flipVertical: { size: 'large' },    //上下翻转
    }
}
let preview = null

export default class PhotoView extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            list:[]
        }
    }

    /*预览打开*/
    show = () => {
        let img_tmp = []
        const imgType = ['png', 'jpg', 'jpeg', 'bmp', 'gif']
        let { imgData } = this.props
        imgData.map(item => {
            let flieArr = item.split('.');
            if (imgType.indexOf(flieArr[flieArr.length - 1].toLowerCase()) != -1) {
                img_tmp.push(item)
            }
        })
        this.setState({
            list: img_tmp
        }, () => {
            preview.viewer.show()
        })
        
    }
    render() {
        return (
            <div>
                <RcViewer
                    options={options}
                    ref={(demo) => { preview = demo }}
                >
                    {
                        this.state.list.map((item, index) => {
                            return (
                                <div key={index}>
                                    <img src={item} alt="" style={{ width: 0, height: 0 }} />
                                </div>
                            )
                        })
                    }
                </RcViewer>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Content/Common/photoView.js